/* 
Author:Lamiaa Moustafa
Desc: Ghost button for navigation dropdown 
*/
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { RiArrowDownSFill } from "react-icons/ri";
import { GhostButton } from "react-hamburger-menus";
import "react-hamburger-menus/dist/style.css";


const GhostButtonAsDropdownLink = () => {
  return (
    <div className="App">
      <GhostButton
        icon={
          <p
            className="NavLink"
            style={{
              color: "#fff",
              fontSize: "18px",
              fontFamily:"var(--fontFamily)"
            }}
          >
            User Manager <RiArrowDownSFill />
          </p>
        }
        styles={{
          floatButtonY: 40,
          floatButtonX: 10,
          navigationCard: {
            backgroundColor: "#fff",
            border:"1px solid var(--orange)",
            minHeight:"100px"
          },
          navigationButton: {
            borderRadius: "10px",
            border: "none",
            // In case you need static not fixed
            position: "relative",
            width: "150px",
            // height: "60px",
            backgroundColor: "transparent",
            zIndex: 10,
            boxShadow: "none",
          },
          navigationIcon: {
            zIndex: 10,
          },
          iconColor: "var(--orange)",
        }}
      >
        <ul>
          <NavLink  to="/register">
            Register
          </NavLink>
          <NavLink  to="/accesscontrol">
            Access Control
          </NavLink>
        </ul>
      </GhostButton>
    </div>
  );
};

export default GhostButtonAsDropdownLink;


const NavLink = styled(Link)`
  color: var(--orange);
  font-family:var(--fontFamily);
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-size:18px;
  letter-spacing:1.2px;
  &:hover{
     color: var(--Gray);
    transform: scale(0.95);
    transition: all 0.5s ease-in-out;
    text-decoration: underline;
  }
  /* &.active {
    font-weight:var(--boldFont);
    text-decoration:underline;
  } */
`;

